import { Job } from "~/components/build/Show/lib/types";
import { totalAnnotationCount } from "~/components/build/Show/components/AnnotationsBadge";

interface Props {
  job: Job;
}

export default function AnnotationsCount({ job }: Props) {
  const annotationsCount = totalAnnotationCount(job.statistics.annotationCountsByStyle || {});

  if (!annotationsCount) {
    return null;
  }

  return <span className="badge badge--outline tabular-numerals ml-1">{annotationsCount}</span>;
}
